import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Chip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { CATEGORY_COLORS } from "./constants";
/**
 * Same visual language as ReviewChangesTable (old value struck through, new
 * value plain) but built on DataGrid since a reconciliation diff spans many
 * voters instead of a single record's fields. Callers split rows by `target`
 * into separate external-side/Sequent-side tables, so this component doesn't
 * need to render which side a row belongs to. Client-side paginated: the
 * whole diff is fetched at once.
 */
export var SyncDiffTable = function (_a) {
    var rows = _a.rows, emptyMessage = _a.emptyMessage;
    var t = useTranslation().t;
    var columns = [
        { field: "voterId", headerName: t("reconciliation.table.voterId"), width: 120 },
        { field: "label", headerName: t("reconciliation.table.field"), width: 180 },
        {
            field: "category",
            headerName: t("reconciliation.table.category"),
            width: 200,
            renderCell: function (params) { return (_jsx(Chip, { size: "small", label: t("reconciliation.categories.".concat(params.row.category), params.row.category), color: CATEGORY_COLORS[params.row.category] })); },
        },
        {
            field: "oldValue",
            headerName: t("reconciliation.table.currentValue"),
            width: 160,
            renderCell: function (params) { return (_jsx(Box, { component: "del", sx: { opacity: 0.6 }, children: params.row.oldValue })); },
        },
        { field: "newValue", headerName: t("reconciliation.table.newValue"), width: 160 },
        {
            field: "failureReason",
            headerName: t("reconciliation.table.reason"),
            flex: 1,
            minWidth: 220,
        },
    ];
    if (rows.length === 0) {
        return (_jsx(Typography, { color: "text.secondary", sx: { py: 2 }, children: emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : t("reconciliation.table.noDifferences") }));
    }
    return (_jsx(DataGrid, { autoHeight: true, rows: rows, columns: columns, density: "compact", getRowId: function (row) { return row.id; }, initialState: {
            pagination: {
                paginationModel: { pageSize: 10 },
            },
        }, pageSizeOptions: [10, 25, 50], disableRowSelectionOnClick: true }));
};
export default SyncDiffTable;
